module.exports = __webpack_public_path__ + "img/75727.2652c0eb.svg";